/* The tag chip and the eight-swatch picker (piece 13). Every colour here comes
   from the tag palette in tokens.css; nothing in this file names a hex. */

.chip {
  display: inline-flex;
  align-items: center;
}

.picker {
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}

.legend {
  padding: 0;
  font-size: var(--control-label-size);
  color: var(--text-muted);
}

.swatches {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-block-start: var(--space-1);
}

.option {
  display: inline-flex;
}

/* Hidden to the eye, present to the keyboard and the screen reader: the label
   beside it is the visible control, and :focus-visible below reflects the ring
   back onto it. */
.input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.swatch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--tag-swatch-size);
  height: var(--tag-swatch-size);
  border-radius: var(--radius-medium);
  background: var(--swatch-bg);
  /* Unselected, the edge is the swatch's own text hex at its thin width; the
     swatch is legible as a shape before it is chosen, the same rule the chip
     follows. */
  border: var(--tag-chip-border-width) solid var(--swatch-text);
  cursor: pointer;
}

/* The chosen swatch thickens its edge rather than adding a tick, so the
   selection is visible without covering the colour being chosen. */
.input:checked + .swatch {
  border-width: var(--tag-swatch-border-width);
  box-shadow: 0 0 0 var(--tag-chip-border-width) var(--swatch-text);
}

.input:focus-visible + .swatch {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* The colour's name is read out and is not drawn: eight words across a row
   would be a list, not a palette. The name is what a screen reader announces
   and what makes the choice more than a colour cue. */
.swatchName {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* The tag pill (decision 2260): the Pill's stadium, bold and outlined in its own
   foreground, with the category's glyph before the label. It is drawn here and
   not by the Pill because the Pill carries no icon, and its box tokens are the
   Pill's own. */
.tagPill {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 0 var(--space-2);
  border-radius: var(--radius-stadium);
  border: var(--tag-chip-border-width) solid currentColor;
  font-weight: var(--font-weight-bold);
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
}

.tagPillSmall {
  height: var(--pill-height-small);
  font-size: var(--font-size-pill-small);
}

.tagPillMedium {
  height: var(--pill-height-medium);
  font-size: var(--font-size-pill-medium);
}

/* The sixteen icons, eight across, as the category editor draws them (screen D). */
.icons {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: var(--space-1);
  margin-block-start: var(--space-1);
}

.iconChoice {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: var(--tag-swatch-size);
  border: var(--tag-chip-border-width) solid var(--border);
  border-radius: var(--radius-small);
  color: var(--text);
  cursor: pointer;
}

.input:checked + .iconChoice {
  border: var(--tag-swatch-border-width) solid var(--accent);
  background: var(--tag-blue-bg);
  color: var(--accent);
}

.input:focus-visible + .iconChoice {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}
